module.exports = __webpack_public_path__ + "yandex_kassa_visa_master_card.8f0c1f7471644fd4af9134439bd369ba.png";